module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-mobile-d6cf4e8ad94aa64572323d9d710e024e.jpg";